import { render } from "./SideMenuComponent.vue?vue&type=template&id=662758a0&scoped=true"
import script from "./SideMenuComponent.vue?vue&type=script&lang=js"
export * from "./SideMenuComponent.vue?vue&type=script&lang=js"

import "./SideMenuComponent.vue?vue&type=style&index=0&id=662758a0&scoped=true&lang=css"

import exportComponent from "/Users/mac/MyDev/3-READY/v2t/vid2text/youtest.ru/youtest-front-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662758a0"]])

export default __exports__